<div class="custom_popup w-100">
    <!-- <i type="button" (click)="closebuttonsuc()" class="color-4 fs-2 far fa-times-circle position-absolute end-0 top-0 m-3 close-button-succes team"></i> -->
    <div class="text-center">
        <img src="assets/img/home/success 1.png">
        <h2 class="text-1 fs-4 mt-4">{{"SIGNUP.success" | translate}}</h2>
        <p class="text-muted font-large h3 mb-2">{{successmessage}}</p>
        <button class="btn btn-1 bg-1 p-3 w-100 color-00 h5 shadow-sm rounded-pill mt-3"
            (click)="cancelModel()">{{"COMMON.Close"|translate}}</button>
    </div>
</div>